/** Whether the CEO company benchmark should be offered before a full assessment. */
export function needsPreSurveyBeforeFull({ userData, assessmentTrack, inviteFlow }) {
  if (userData?.pre_survey !== "Y") return false;
  if (assessmentTrack === "lite" && inviteFlow === "v2_lite") return false;
  return (
    inviteFlow === "v1_full" ||
    inviteFlow === "v2_full_continuation" ||
    assessmentTrack === "full"
  );
}

export function preSurveyStillPending(userData) {
  return userData?.pre_survey === "Y";
}
